<template>
  <div class="discount-details">
    <v-list three-line>
      <v-list-item>
        <v-list-item-avatar>
          <v-img
            v-if="discount.storeAvatar"
            v-bind:src="discount.storeAvatar"
          />
          <v-avatar v-else color="grey" size="40">
            <span class="white--text headline">{{
              discount.title.charAt(0).toUpperCase()
            }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ discount.title }}</v-list-item-title>
          <v-list-item-subtitle
            >{{ discount.storeName }},
            {{ discount.cityName }}</v-list-item-subtitle
          >
          <v-list-item-subtitle>
            {{ formatDate(discount.start) }} bis
            {{ formatDate(discount.end) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            @click="$navigateTo('Store', { storeId: discount.storeId })"
            icon
          >
            <v-icon>mdi-storefront-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-img class="picture" :src="discount.picture" />

    <v-container>
      <v-row>
        <v-col cols="10" offset="1" class="description">
          <p v-html="discount.description"></p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.picture {
  height: 35vh;
}

.description {
  text-align: justify;
  font-size: 0.9rem;
}
</style>

<script>
export default {
  name: "DiscountDetails",

  props: ["discount"],

  methods: {
    formatDate: function(value) {
      let date = new Date(value);
      return date.toLocaleDateString("de-de", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    }
  }
};
</script>
